export const DESIGNATION = "DESIGNATION";
export const DESIGNATION_SUCCESS = "DESIGNATION_SUCCESS";
export const DESIGNATION_FAILED = "DESIGNATION_FAILED";

export const ADD_DESIGNATION = "ADD_DESIGNATION";
export const ADD_DESIGNATION_SUCCESS = "ADD_DESIGNATION_SUCCESS";
export const ADD_DESIGNATION_FAILED = "ADD_DESIGNATION_FAILED";

export const UPDATE_DESIGNATION = "UPDATE_DESIGNATION";
export const UPDATE_DESIGNATION_SUCCESS = "UPDATE_DESIGNATION_SUCCESS";
export const UPDATE_DESIGNATION_FAILED = "UPDATE_DESIGNATION_FAILED";